import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import IconSvg from "./IconSvg";
import stl from "./ReservedMessage.module.css";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import useHelpers from "@hooks/useHelpers";
var ReservedMessage = function ReservedMessage() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ReservedMessageWrapper
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconSvg, null), /*#__PURE__*/React.createElement("strong", null, t("error_apologize", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", null, t("car_booked_another_customer_one", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    className: "".concat(stl.btn, " blueBtn"),
    onClick: function onClick() {
      navigateTo("/filters");
    }
  }, t("similar_cars", {
    ns: "web_checkout_cash"
  }))));
};
export default ReservedMessage;